import React from 'react';
import './container.css';

function Container({ children, wide }: any) {
    return <div className={`${wide ? 'wide-container' : 'container'}`}>{children}</div>;
}

export default Container;